import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-start-review-total-panel',
  templateUrl: './start-review-total-panel.component.html',
  styleUrls: ['./start-review-total-panel.component.scss'],
})
export class StartReviewTotalPanelComponent implements OnChanges {
  stars = Array(5);
  @Input() start1 = 0;
  @Input() start2 = 0;

  selected = 0;

  ngOnChanges(changes: SimpleChanges): void {
    this.selected = (this.start1 + this.start2) / 2;
  }

  getFill(index: number) {
    const diff = this.selected - index;
    if (diff >= 1) return '100%';
    if (diff <= 0) return '0%';
    return diff * 100 + '%';
  }
}
